import { Link, NavLink } from "react-router-dom";
import { ShoppingCart, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_uk-peptide-supply/artifacts/mjzekzzr_Screenshot_20260424_194411_ChatGPT.jpg";

const navLinkClass = ({ isActive }) =>
  `text-sm tracking-wide uppercase font-medium transition-colors ${
    isActive ? "text-[#2C8C9C]" : "text-[#0F172A] hover:text-[#2C8C9C]"
  }`;

export const Header = () => {
  const { itemCount } = useCart();
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-white border-b border-[#E2E8F0]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Sterling Bio" className="h-12 w-12 object-contain" />
          <div className="leading-tight">
            <div className="text-[#1B3A5C] font-semibold tracking-tight text-lg" style={{ fontFamily: "Outfit" }}>
              STERLING <span className="text-[#2C8C9C]">BIO</span>
            </div>
            <div className="sb-mono-label">Advanced bio solutions</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={navLinkClass} data-testid="nav-home">Home</NavLink>
          <NavLink to="/products" className={navLinkClass} data-testid="nav-products">Catalogue</NavLink>
          <NavLink to="/compliance" className={navLinkClass} data-testid="nav-compliance">Compliance</NavLink>
          <NavLink to="/terms" className={navLinkClass} data-testid="nav-terms">Terms</NavLink>
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/cart"
            data-testid="cart-link"
            className="relative inline-flex items-center gap-2 border border-[#1B3A5C] px-4 py-2 text-sm font-medium text-[#1B3A5C] hover:bg-[#1B3A5C] hover:text-white transition-colors"
          >
            <ShoppingCart className="w-4 h-4" />
            <span className="hidden sm:inline">Cart</span>
            <span data-testid="cart-count" className="font-mono text-xs px-2 py-0.5 bg-[#2C8C9C] text-white">
              {itemCount}
            </span>
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden p-2 text-[#1B3A5C]"
            aria-label="Toggle navigation"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E2E8F0] bg-white">
          <div className="px-4 py-4 flex flex-col gap-4">
            <NavLink to="/" end className={navLinkClass} onClick={() => setOpen(false)}>Home</NavLink>
            <NavLink to="/products" className={navLinkClass} onClick={() => setOpen(false)}>Catalogue</NavLink>
            <NavLink to="/compliance" className={navLinkClass} onClick={() => setOpen(false)}>Compliance</NavLink>
            <NavLink to="/terms" className={navLinkClass} onClick={() => setOpen(false)}>Terms</NavLink>
            <NavLink to="/refund-policy" className={navLinkClass} onClick={() => setOpen(false)}>Refund Policy</NavLink>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
